import React from 'react';
import PropTypes from 'prop-types';

import { CONTENT_PROPS } from '../shared/constants';
import WithErrorBoundary from '../../HOCs/WithErrorBoundary';
import PlayLogo from '../../static/images/play-button.svg';
import AddLogo from '../../static/images/add.svg';

import { getContentImageByMode } from '../../utils/imageUtils';

//#region ///// DUCKS ////
import * as hooks from './hooks';
import './styles.scss';
//#endregion

function ContentHeader({
  addButtonTitle,
  content,
  ctaButtonTitle,
  customAddButtonIcon = null,
  customCTAButtonIcon = null,
  disableAnimation = false,
  hideButtons = false,
  hideButtonIcons = false,
  onClickAddButtonHandler = () => alert('"onClickAddButtonHandler" Not implemented!'),
  onClickCTAButtonHandler = () => alert('"onClickCTAButtonHandler" Not implemented!')
}) {
  const getBackgroundImageURL = React.useCallback(
    (imagesArray) => {
      let imageURL = null;
      const found = getContentImageByMode(imagesArray, 'THUMB');
      imageURL = found && found.url;

      if (!imageURL) {
        throw Error('Content must have an image of type "THUMB" to render!');
      }
      return imageURL;
    }, []
  );

  //#region //// HOOKS ////
  const { mounted } = hooks.useDidMount();
  //#endregion

  if (!content) {
    return (
        <header className="header">
          <div className="tbx-ContentHeader__container">
          </div>
        </header>
    );
  }

  const backgroundStyle = {
    backgroundSize: 'cover',
    backgroundImage: `url(${getBackgroundImageURL(content.images)})`,
    backgroundPosition: 'center',
  };

  return (
    <header style={backgroundStyle} className="tbx-ContentHeader">
      <div className="tbx-ContentHeader__container">
        <h1 className={`tbx-ContentHeader__container-heading ${disableAnimation ? '' : 'animatedtitle' } ${mounted ? 'animate' : ''}`}>
        {content.title}
        </h1>
        { !hideButtons &&
          <div>
            <button
              className="tbx-ContentHeader__container-btnPlay"
              onClick={onClickCTAButtonHandler}
            >
              <img className="tbx-ContentHeader__container-btnMyList-play" src={customCTAButtonIcon || PlayLogo} alt="play"/>
              { ctaButtonTitle || 'Play' }
            </button>

            <button
              className="tbx-ContentHeader__container-btnMyList"
              onClick={onClickAddButtonHandler}
            >
              <img className="tbx-ContentHeader__container-btnMyList-add" src={customAddButtonIcon || AddLogo} alt="add"/>
              { addButtonTitle || 'My List' }
            </button>
          </div>
        }
        <p className="tbx-ContentHeader__container-overview">{content.description}</p>
      </div>
      <div className={`tbx-ContentHeader--fadeBottom ${disableAnimation ? '' : 'animatedbottom' } ${mounted ? 'animate' : ''}`}></div>
    </header>
  );
}

ContentHeader.propTypes = {
  addButtonTitle: PropTypes.string,
  content: PropTypes.shape(CONTENT_PROPS).isRequired,
  ctaButtonTitle: PropTypes.string,
  customAddButtonIcon: PropTypes.func,
  customCTAButtonIcon: PropTypes.func,
  disableAnimation: PropTypes.bool,
  hideButtons: PropTypes.bool,
  hideButtonIcons: PropTypes.bool,
  onClickAddButtonHandler: PropTypes.func,
  onClickCTAButtonHandler: PropTypes.func
};

export default WithErrorBoundary(React.memo(ContentHeader));